import 'antd/dist/reset.css';
import { ApolloProvider } from '@apollo/client/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { client } from '@guuru/graphql-web';
import { initSentry, handleError, Sentry } from '@guuru/sentry-web';
import { i18n } from '@guuru/translation-web';
import MainView from '../../navigation/MainView';

if (process.env.CHAT_SENTRY_DSN) {
  initSentry(process.env.CHAT_SENTRY_DSN, {
    ignoreErrors: [/(?:sw|x)browser is not defined/],
  });
}

const CommunityApp = Sentry.withProfiler(() => (
  <ApolloProvider client={client}>
    <I18nextProvider i18n={i18n}>
      <MainView />
    </I18nextProvider>
  </ApolloProvider>
));

const container = document.getElementById('app');
const root = createRoot(container, {
  onCaughtError: handleError,
  onRecoverableError: handleError,
  onUncaughtError: handleError,
});
root.render(<CommunityApp />);
